export default {
    //apiUrl: 'http://192.168.68.50:82/api/v1.0'
    apiUrl: 'https://stageapp.claysyslifestyle.com/api/v1.0'
}